import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TokenStorageService {
    private readonly accessTokenKey = 'accessToken';
    private readonly refreshTokenKey = 'refreshToken';

    getAccessToken(): string | null {
        return sessionStorage.getItem(this.accessTokenKey);
    }

    getRefreshToken(): string | null {
        return sessionStorage.getItem(this.refreshTokenKey);
    }

    setAccessToken(token: string): void {
        sessionStorage.setItem(this.accessTokenKey, token);
    }

    setRefreshToken(token: string): void {
        sessionStorage.setItem(this.refreshTokenKey, token);
    }

    clear(): void {
        sessionStorage.removeItem(this.accessTokenKey);
        sessionStorage.removeItem(this.refreshTokenKey);
    }
}
